
import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useIsAuthenticated } from "@azure/msal-react";
import isLoggedIn from '../utils/auth';


const ExternalRoute = () => {

  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if(isLoggedIn() || isAuthenticated) {
    return <Navigate to='/diamonds' state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ExternalRoute;